import { useCallback } from "react";
import useApiClient from "../services/axiosInstance";

export const useSavingGoals = () => {
  const { api } = useApiClient();

  const saveGoals = useCallback(
    async (data) => {
      try {
        const response = await api.post("/api/goal-detail/save", data);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    [api]
  );
  const getGoals = useCallback(
    async (data) => {
      try {
        const response = await api.post("/api/goal-detail/fetch", data);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    [api]
  );
  return { saveGoals, getGoals };
};
